export const hasActiveSenderConnection = (connections = []) => {
    return connections.some((connection) => connection.is_active === true);
};
